import { addTranslation, setLanguage } from "media-chrome/utils/i18n.js"
import "media-chrome/lang/de.js"
import "media-chrome/lang/es.js"
import { mediaChromeNl } from "../PlayerCore/mediaChromeNl.js"
import { provideCoreI18n } from "../PlayerCore/useCoreI18n.js"
import { createTranslator, resolveLocale } from "./i18n.js"

addTranslation("nl", mediaChromeNl)

/**
 * Call once from the podcast page's setup, before any media-chrome element is created:
 * media-chrome renders its tooltips with t() in each element's constructor, so the language must
 * already be set at mount. Provides the podcast translator (core + podcast keys) to PlayerCore.
 */
export function provideVideoI18n(locale) {
    const resolved = resolveLocale(locale)

    setLanguage(resolved)

    const t = createTranslator(resolved)

    provideCoreI18n(t)

    return { t, locale: resolved }
}
